import { ComponentsManager, Component, EventBus } from '../core/smpl-components.js'
import { ThumbSlider } from '../modules/thumb-slider.js'
import { SliderControls } from '../modules/slider-controls.js'
import { StackFade } from '../modules/embla-stack-fade.js'
import { MqlMatchMedia } from '../utils/mql-match-media.js'

// Keep in sync with --desktop-slider in _program.scss.
const STACK_AT = '(min-width: 769px)'

export default class extends Component {
	prepare() {
		this.elPanels = Array.from(this.element.querySelectorAll('.highlights-slider__panel'))
		this.elSlides = Array.from(this.element.querySelectorAll('.highlights-slider__slide'))

		this.slider = new ThumbSlider({
			container: this.element.querySelector('.highlights-slider__viewport'),
			element: this.element.querySelector('.highlights-slider__container'),
			emblaOptions: {
				// The stacked slides don't move, so a drag would have no visual feedback.
				breakpoints: { [STACK_AT]: { watchDrag: false } },
			},
		})

		this.embla = this.slider.getInstance()

		this.initStack()

		this.controls = new SliderControls({
			embla: this.embla,
			element: this.element.closest('.slider-section')?.querySelector('.js-slider-controls'),
		})

		this.bndOnSelect = this.onSelect.bind(this)
		this.embla.on('select', this.bndOnSelect)

		this.onSelect()
	}

	/**
	 * On desktop the slides are stacked and crossfaded instead of scrolled. StackFade has
	 * no breakpoint handling of its own, so it gets added and removed by re-initializing
	 * the carousel — which keeps the options and the selected slide.
	 */
	initStack() {
		this.stackActive = false

		this.mqlStack = new MqlMatchMedia(STACK_AT, (matches) => {
			if (matches === this.stackActive) return

			this.stackActive = matches
			this.embla.reInit(undefined, this.stackActive ? [StackFade()] : [])
		})
	}

	onSelect() {
		const index = this.embla.selectedScrollSnap()
		const prevIndex = this.embla.previousScrollSnap()

		this.elPanels.forEach((el, i) => {
			el.classList.toggle('is-active', i === index)
		})

		// The outgoing slide stays fully opaque under the incoming one while it fades in,
		// so the stack is never see-through. See StackFade + _program.scss.
		this.elSlides.forEach((el, i) => {
			el.classList.toggle('is-active', i === index)
			el.classList.toggle('was-active', i === prevIndex && prevIndex !== index)
		})
	}

	mount() {}

	unmount() {
		if (this.mqlStack) {
			this.mqlStack.destroy()
		}
		if (this.controls) {
			this.controls.destroy()
		}
		if (this.embla) {
			this.embla.off('select', this.bndOnSelect)
		}
		if (this.slider) {
			this.slider.destroy()
		}
	}
}
